import React, { forwardRef } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

/**
 * DKNDropDown — Daikin design system single-select dropdown.
 * Wraps Kendo DropDownList.
 *
 * Props:
 *   data        Array — items list
 *   value       any — controlled value
 *   onChange    (e) => void
 *   textField   string — field name for display (default: "text")
 *   dataItemKey string — field name for value   (default: "value")
 *   label       string — label above the input
 *   error       string — red helper text below
 *   placeholder string
 *   fullWidth   boolean (default: false)
 *   disabled    boolean
 */
const DKNDropDown = forwardRef(function DKNDropDown(
  {
    data = [],
    value,
    onChange,
    textField = "text",
    dataItemKey = "value",
    label,
    error,
    placeholder,
    fullWidth = false,
    disabled = false,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <DropDownList
        ref={ref}
        data={data}
        value={value}
        onChange={onChange}
        textField={textField}
        dataItemKey={dataItemKey}
        defaultItem={placeholder ? { [textField]: placeholder, [dataItemKey]: null } : undefined}
        disabled={disabled}
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNDropDown;
